import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_EMBEDDED_PLAYER_STREAM_CONTENT,
  SET_EMBEDDED_PLAYER_STREAM_LOADING
} from '../actions/embeddedPlayerStreamActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

const DEFAULT_STATE = {
  isLoading: false,
  isLoaded: false
};

export default function embeddedPlayerStreamReducer(
  state: Partial<TCharacterDetailsClientState> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_EMBEDDED_PLAYER_STREAM_LOADING: {
      const newState: any = {
        ...state,
        isLoading: action.payload.loading,
        isLoaded: !action.payload.loading
      };
      return newState;
    }
    case SET_EMBEDDED_PLAYER_STREAM_CONTENT: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isLoaded: true
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default: {
      return state;
    }
  }
}
